import { createTheme } from "@mui/material/styles";
import { defaults } from "./defaults";

import type {} from "@mui/x-data-grid/themeAugmentation";
import type {} from "@mui/x-charts/themeAugmentation";
import { frFR } from "@mui/x-data-grid/locales";

import "./types";

const cadaPalette = {
    ...defaults,
    palette: {
        ...defaults.palette,
        primary: {
            main: "#B61D22",
        },
        secondary: {
            main: "#EE232E",
        },
        background: {
            default: "#f2f2f2",
            paper: "#ffffff",
        },
        text: {
            primary: "#1C1B1B",
            secondary: "#666666",
        },
    },
};

export const createCadaTheme = (locale: "en" | "fr" = "en") => {
    if (locale === "fr") {
        return createTheme(cadaPalette, frFR);
    }
    return createTheme(cadaPalette);
};

const cadaTheme = createCadaTheme();

export default cadaTheme;
